import { SVGInterface } from "../../interface";

const Error = ({ color, ...rest }: SVGInterface) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2.00607 6.47966 6.47967 2.00606 12 2ZM20 11.828C19.9527 7.42676 16.3589 3.89046 11.9575 3.914C7.55603 3.93777 4.00046 7.51251 4.00046 11.914C4.00046 16.3155 7.55603 19.8902 11.9575 19.914C16.3589 19.9375 19.9527 16.4012 20 12L20 11.828Z"
      fill={color || "#0E171F"}
    />
    <path d="M13 15L11 15L11 17L13 17L13 15Z" fill={color || "#0E171F"} />
    <path d="M13 7L11 7L11 13L13 13L13 7Z" fill={color || "#0E171F"} />
  </svg>
);

export default Error;
